export default __webpack_public_path__ + "static/IBM-Plex-Mono-600italic-aec0bfac06017e6ab33c3b50b901434f.woff";